// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ExpandableClamp__label":"bbf_a bhc_hg bhc_ry bhc_xj"};